export default {
  UserShortcut_find: {
    path: '/UserShortcuts/find',
  },
  UserSnippet_find: {
    path: '/user-snippets/find',
  },
  UserFunction_find: {
    path: '/user-functions/find',
  },
  UserFunction_getDefinedFunctions: {
    path: '/user-functions/user-functions',
  },
  QueryParam_find: {
    path: '/QueryParams/find',
  },
  DocumentStorage_find: {
    path: '/DocumentStorages/find',
  },
  DocumentStorage_checkFile: {
    path: '/DocumentStorages/checkFile',
  },
  DocumentStorage_getDocument: {
    path: '/DocumentStorages/get-documents',
  },
  ProcessBuilder_getConfirmationMessage: {
    path: '/ProcessBuilders/get-confirmation-message'
  },
  ProcessBuilder_runProcess: {
    path: '/ProcessBuilders/run-process',
    queryKeys: ['id'],
  },
  ProcessBuilder_runProcesses: {
    path: '/ProcessBuilders/run-processes',
    method: 'post',
  },
  ProcessBuilder_findOne: {
    path: '/ProcessBuilders/findOne',
  },
  ProcessBuilder_getProcessContent: {
    path: '/ProcessBuilders/get-process-content',
  },
  ProcessBuilder_model: {
    path: '/ProcessBuilders/model',
  },
  ProcessBuilder_getSystemList: {
    path: '/ProcessBuilders/system-list',
  },
  ProcessBuilder_instanceList: {
    path: '/ProcessBuilders/instance-list',
  },
  ProcessBuilder_pickList: {
    path: '/ProcessBuilders/picklist',
  },
  ProcessBuilder_saveData: {
    path: '/ProcessBuilders/save-data',
    method: 'post',
  },
  ProcessBuilder_find: {
    path: '/ProcessBuilders/find',
  },
  ProcessList_getSetup: {
    path: '/ProcessLists/get-setup',
  },
  ProcessList_getData: {
    path: '/ProcessLists/get-data',
  },
  ProcessQueue_get: {
    path: '/ProcessQueues/get',
  },
  Localization_find: {
    path: '/Localizations/find',
  },
  Localization_filter: {
    path: '/Localizations/filter',
  },
  Localization_lastModify: {
    path: '/Localizations/last-modify',
  },
  Localization_saveData: {
    path: '/Localizations/save-data',
    method: 'post',
  },
  Localization_translateLang: {
    path: '/Localizations/translate-lang',
    method: 'post',
  },
  Localization_translationProgress: {
    path: '/Localizations/translation-progress',
    method: 'get',
  },
  Localization_bulkUpsert: {
    path: '/Localizations/bulk-upsert',
    method: 'post',
  },
  Notification_loadNotifications: {
    path: '/Notifications/load-notifications',
    method: 'get',
  },
  Notification_readNotifications: {
    path: '/Notifications/read-notification',
  },
  Notification_saveNotification: {
    path: '/Notifications/save-notification',
    method: 'post',
  },
  Notification_clearNotification: {
    path: '/Notifications/clear-notification',
    method: 'post',
  },
  Notification_countNotifications: {
    path: '/Notifications/count-notifications',
    method: 'get',
  },
  SqlLibrary_getButtonList: {
    path: '/SqlLibraries/get-button-list',
  },
  SqlLibrary_executePromise: {
    path: '/SqlLibraries/executePromise',
  },
  DesignerRule_getAllRule: {
    path: '/DesignerRules/get-all-rule',
  },
  Dynform_saveData: {
    path: '/Dynforms/save-data',
    method: 'post',
  },
  Dynform_save: {
    path: '/Dynforms/replaceorcreate',
    method: 'post',
  },
  Dynform_getFormDesignerSchema: {
    path: '/Dynforms/get-form-designer-schema',
  },
  Dynform_postFormDesignerSchema: {
    path: '/Dynforms/post-form-designer-schema',
    method: 'post',
  },
  Dynform_fdSave: {
    path: '/Dynforms/form-designer-save',
    method: 'post',
  },
  Dynform_formVerification: {
    path: '/Dynforms/form-verification',
    method: 'post',
  },
  Dynform_getData: {
    path: '/Dynforms/get-data',
  },
  Dynform_refreshData: {
    path: '/Dynforms/refresh-data',
  },
  Dynform_listValue: {
    path: '/Dynforms/listvalue',
  },
  Dynform_getForms: {
    path: '/Dynforms/get-forms',
  },
  Dynform_getFormList: {
    path: '/Dynforms/get-form-list',
  },
  Dynform_getSubForms: {
    path: '/Dynforms/get-sub-forms',
  },
  Dynform_getFormStatus: {
    path: '/Dynforms/get-form-status',
  },
  Dynform_getFormStatusHistory: {
    path: '/Dynforms/get-form-status-history',
  },
  Dynform_getDataTemplate: {
    path: '/Dynforms/get-data-template',
  },
  Dynform_getProperties: {
    path: '/Dynforms/properties',
  },
  Dynform_pathfinder: {
    path: '/Dynforms/pathfinder',
  },
  Dynform_connections: {
    path: '/Dynforms/connections',
  },
  Dynform_expressionEval: {
    path: '/Dynforms/expression-eval',
  },
  Dynform_getSubsystemList: {
    path: '/Dynforms/get-subsystem-list',
  },
  Dynform_findOne: {
    path: '/Dynforms/findOne',
  },
  Dynform_find: {
    path: '/Dynforms/find',
  },
  Dynform_multicomplete: {
    path: '/Dynforms/multicomplete',
  },
  Dynform_multicompleteValue: {
    path: '/Dynforms/multicompletevalue',
  },
  Dynform_validateExpression: {
    path: '/Dynforms/validate-expression',
    method: 'post',
    dataKey: 'data',
    contentType: 'application/json',
  },
  Dynform_htmlCache: {
    path: '/Dynforms/html-cache',
    method: 'post',
  },
  Dynform_getTableProperties: {
    path: '/Dynforms/get-table-properties',
  },
  Dynform_getAvailableTables: {
    path: '/Dynforms/get-available-tables',
  },
  Dynform_getGeneratedTableName: {
    path: '/Dynforms/get-generated-table-name',
  },
  Dynform_availableFormsTables: {
    path: '/Dynforms/available-forms-tables',
  },
  Dynform_getFormFields: {
    path: '/Dynforms/get-form-fields',
  },
  Dynform_getTableFields: {
    path: '/Dynforms/get-table-fields',
  },
  Dynform_getTableFieldsWithType: {
    path: '/Dynforms/get-table-fields-with-type',
  },
  Dynform_verifySubformRecord: {
    path: '/Monitorings/verify-subform-record',
  },
  Dynform_getPatterns: {
    method: 'get',
    path: '/Dynforms/get-masks',
  },
  Dynform_getTreeById: {
    method: 'get',
    path: '/Dynforms/get-tree-by-id',
  },
  Dynform_importProgress: {
    method: 'get',
    path: '/Dynforms/import-progress',
  },
  Dynform_importResult: {
    method: 'get',
    path: '/Dynforms/import-result',
  },
  Dynform_getEnumData: {
    method: 'get',
    path: '/Dynforms/get-enum-data',
  },
  Dynform_getSqlChosenList: {
    method: 'get',
    path: '/Dynforms/get-sql-chosen-list',
  },
  Dynform_getListSourceFields: {
    path: '/Dynforms/get-list-source-fields',
  },
  Dynform_getFormMeta: {
    path: '/Dynforms/get-form-meta',
  },
  Gantt_batchSave: {
    path: '/Gantts/batch-save',
  },
  Gantt_updateOrder: {
    path: '/Gantts/update-order',
  },
  Gantt_nextSeq: {
    path: '/Gantts/next-seq',
  },
  Gantt_deleteTask: {
    path: '/Gantts/delete-task',
  },
  Map_getLayerData: {
    path: '/Maps/get-layer-data',
  },
  Map_getData: {
    path: '/Maps/get-data',
  },
  Lock_lockForm: {
    path: '/Locks/lock-form',
  },
  Lock_lock: {
    path: '/Locks/lock',
  },
  Lock_unlock: {
    path: '/Locks/unlock',
  },
  Lock_isLocked: {
    path: '/Locks/is-locked',
  },
  List_getList: {
    path: '/Lists/get-list',
    method: 'post',
  },
  List_getListSetup: {
    path: '/Lists/get-list-setup',
  },
  List_getButtonList: {
    path: '/Lists/get-button-list',
    method: 'post',
  },
  List_exportList: {
    path: '/Lists/export-list',
    method: 'post',
  },
  List_getCode: {
    path: '/Lists/get-code',
  },
  GridLayout_find: {
    path: '/GridLayouts/find',
  },
  GridLayout_findOne: {
    path: '/GridLayouts/find',
    first: true,
  },
  LayoutManager_get: {
    path: '/LayoutManagers/get',
  },
  LayoutManager_upsertWithWhere: {
    path: '/LayoutManagers/upsertWithWhere',
    method: 'post',
    dataKey: 'data',
    queryKeys: ['where'],
    contentType: 'application/json',
  },
  LayoutManager_find: {
    path: '/LayoutManagers/find',
  },
  LayoutManager_toolbox: {
    path: '/LayoutManagers/toolbox',
  },
  LayoutManagers_getPopup: {
    path: '/LayoutManagers/getPopup',
  },
  LayoutManager_generateDashboard: {
    path: '/LayoutManagers/generate-dashboard',
  },
  Layout_find: {
    path: '/Layouts/find',
  },
  Layout_findOne: {
    path: '/Layouts/findOne',
  },
  SavedFilter_find: {
    path: '/SavedFilters/find',
  },
  SavedFilter_create: {
    path: '/SavedFilters/add-item',
    method: 'post',
  },
  SavedFilter_removeItem: {
    path: '/SavedFilters/remove-item',
  },
  Url_find: {
    path: '/Urls/find',
  },
  Url_like: {
    path: '/Urls/like-url',
  },
  Url_update: {
    path: '/Urls/upsertWithWhere',
    method: 'post',
    dataKey: 'data',
    queryKeys: ['where'],
    contentType: 'application/json',
  },
  Menu_availableSubsystems: {
    path: '/Menus/available-subsystems',
    method: 'get',
    contentType: 'application/json',
  },
  Menu_upsertWithWhere: {
    path: '/Menus/upsertWithWhere',
    method: 'post',
    dataKey: 'data',
    queryKeys: ['where'],
    contentType: 'application/json',
  },
  Menu_save: {
    path: '/Menus/save',
    method: 'post',
    contentType: 'application/json',
  },
  Menu_findOne: {
    path: '/Menus/findOne',
  },
  Menu_find: {
    path: '/Menus/find',
  },
  Menu_filter: {
    path: '/Menus/filter',
  },
  Menu_getMenuInfo: {
    path: '/Menus/get-menu-info',
  },
  Menu_getItemsForPanel: {
    path: '/Menus/get-items-for-panel',
  },
  ExternalParams_dotoParams: {
    path: '/ExternalParams/dotoParams',
  },
  ExternalParams_getSqlParams: {
    path: '/ExternalParams/get-sql-params',
    method: 'get',
  },
  WorkflowDesigner_loadData: {
    path: '/WorkflowDesigners/load-data',
  },
  WorkflowDesigner_saveData: {
    path: '/WorkflowDesigners/save-data',
    method: 'post',
  },
  WorkflowDesigner_saveConstraints: {
    path: '/WorkflowDesigners/save-constraints',
    method: 'post',
  },
  WorkflowDesigner_getForms: {
    path: '/WorkflowDesigners/get-forms',
  },
  WorkflowDesigner_getFormFields: {
    path: '/WorkflowDesigners/get-form-fields',
  },
  WorkflowDesigner_getFormStates: {
    path: '/WorkflowDesigners/get-form-states',
  },
  WorkflowDesigner_loadWorkflows: {
    path: '/WorkflowDesigners/get-workflows',
  },
  WorkflowDesigner_getProcesses: {
    path: '/WorkflowDesigners/get-processes',
  },
  WorkflowDesigner_getProgress: {
    path: '/WorkflowDesigners/get-progress',
  },
  WorkflowDesigner_getUserGroups: {
    path: '/WorkflowDesigners/get-user-groups',
  },
  WorkflowDesigner_getAssignedTasks: {
    path: '/WorkflowDesigners/get-assigned-task',
  },
  Workflow_checkDataIntegrity: {
    path: '/Workflows/dataIntegrityCheck',
  },
  Workflow_step: {
    path: '/Workflows/step',
    method: 'post',
  },
  Workflow_getTasksById: {
    path: '/Workflows/get-task-by-id',
    method: 'get',
  },
  QueryBuilder_buildQuery: {
    path: '/QueryBuilders/build-query',
    method: 'post',
    contentType: 'application/json',
  },
  QueryBuilder_saveQuery: {
    path: '/QueryBuilders/save-query',
    method: 'post',
    contentType: 'application/json',
  },
  QueryBuilder_getDropdownQuery: {
    path: '/QueryBuilders/get-dropdown-query',
  },
  QueryBuilder_getQuery: {
    path: '/QueryBuilders/get-query',
  },
  QueryBuilder_getSourceTables: {
    path: '/QueryBuilders/get-source-tables',
  },
  QueryBuilder_getQueryList: {
    path: '/QueryBuilders/get-query-list',
  },
  QueryBuilder_executeQuery: {
    path: '/QueryBuilders/execute-query',
    method: 'post',
    contentType: 'application/json',
  },
  Changelog_readChangelog: {
    path: '/Changelogs/read-changelog',
    method: 'get',
    contentType: 'application/json',
  },
  Changelog_getLastCommit: {
    path: '/Changelogs/get-last-commit',
  },
  Authority_getDummyUrls: {
    path: '/Authorities/get-dummy-urls',
  },
  Authorities_getPermissionByUrl: {
    path: '/Authorities/get-permission-by-url',
  },
  Subsystem_getEnabledFunctions: {
    path: '/Subsystems/get-enabled-functions',
  },
  Dashboard: {
    path: '/Dashboards/layout',
  },
  Dashboard_setDefault: {
    path: '/Dashboards/setDefault',
    method: 'post',
    contentType: 'application/json',
  },
  Dashboard_loadDefault: {
    path: '/Dashboards/loadDefault',
    method: 'post',
    contentType: 'application/json',
  },
  Dashboard_save: {
    path: '/Dashboards/save',
    method: 'post',
  },
  Monitoring_get: {
    path: '/Monitorings/get',
  },
  Monitoring_parseStoredSql: {
    path: '/Monitorings/parse-stored-sql',
  },
  Monitoring_formFieldInList: {
    path: '/Monitorings/form-field-in-list',
  },
  Monitoring_checkDocsFile: {
    path: '/Monitorings/check-docs-file',
  },
  Monitoring_checkFormsDocsRelations: {
    path: '/Monitorings/check-forms-docs-relations',
  },
  Monitoring_validateExpressions: {
    path: '/Monitorings/all-validate-expressions',
  },
  Monitoring_validateFormCamerasFileExtensions: {
    path: '/Monitorings/validate-form-cameras-file-extensions',
  },
  Monitoring_validateFormConventions: {
    path: '/Monitorings/validate-form-conventions',
  },
  Monitoring_validateTableDefaultValues: {
    path: '/Monitorings/validate-table-default-values',
  },
  Monitoring_validateLocalization: {
    path: '/Monitorings/validate-localization',
  },
  Monitoring_validateUrls: {
    path: '/Monitorings/validate-urls',
  },
  Monitoring_validateUrlsUnclearRights: {
    path: '/Monitorings/validate-urls-unclear-rights',
  },
  Monitoring_checkTestCases: {
    path: '/Monitorings/check-test-cases',
  },
  Monitoring_defaultDashboard: {
    path: '/Monitorings/default-dashboard',
  },
  Monitoring_validateProcessEntityEvents: {
    path: '/Monitorings/validate-process-entity-events',
  },
  Chart_getData: {
    path: '/Charts/get-data',
  },
  Tags_list: {
    path: '/Tags/list',
    method: 'get',
  },
  Theme_findOne: {
    path: '/Themes/findOne',
  },
  Theme_upsertWithWhere: {
    path: '/Themes/upsertWithWhere',
    method: 'post',
    dataKey: 'data',
    queryKeys: ['where'],
    contentType: 'application/json',
  },
  About_upsertWithWhere: {
    path: '/Abouts/upsertWithWhere',
    method: 'post',
    dataKey: 'data',
    queryKeys: ['where'],
    contentType: 'application/json',
  },
  About_findOne: {
    path: '/Abouts/findOne',
  },
  Bookmarks_find: {
    path: '/Bookmarks/find',
  },
  Bookmarks_upsertWithWhere: {
    path: '/Bookmarks/upsertWithWhere',
    method: 'post',
    dataKey: 'data',
    queryKeys: ['where'],
    contentType: 'application/json',
  },
  Captcha_token: {
    path: '/Captchas/token',
  },
  CustomComponents_find: {
    path: '/CustomComponents/find',
  },
  CustomComponents_findById: {
    path: '/CustomComponents/find-by-id',
  },
  CustomComponents_getComponent: {
    path: '/CustomComponents/get-component',
    method: 'get',
  },
  CustomComponents_saveComponent: {
    path: '/CustomComponents/save-component',
    method: 'post',
  },
  JsonForms_find: {
    path: '/JsonForms/find',
  },
  JsonForms_findOne: {
    path: '/JsonForms/findOne',
  },
  JsonForms_load: {
    path: '/JsonForms/load',
  },
  JsonForms_save: {
    path: '/JsonForms/save',
    method: 'post',
  },
  FormDataVersions_findOne: {
    path: '/FormDataVersions/findOne',
  },
  FormDataVersions_getColumns: {
    path: '/FormDataVersions/get-columns',
  },
  IntlLanguage_find: {
    path: '/IntlLanguages/find',
  },
  LangSwitcher_setUserLang: {
    path: '/LangSwitchers/set-user-lang',
    method: 'post',
    contentType: 'application/json',
  },
  Localization_upsertWithWhere: {
    path: '/Localizations/upsertWithWhere',
    method: 'post',
    dataKey: 'data',
    queryKeys: ['where'],
    contentType: 'application/json',
  },
  Checklist_upsertWithWhere: {
    path: '/Checklists/upsertWithWhere',
    method: 'post',
    dataKey: 'data',
    queryKeys: ['where'],
    contentType: 'application/json',
  },
  Checklist_findOne: {
    path: '/Checklists/findOne',
  },
  ConfigManager_getSchema: {
    method: 'get',
    path: '/ConfigManagers/get-schema',
  },
  ConfigManager_save: {
    path: '/ConfigManagers/save',
    method: 'post',
    contentType: 'application/json',
  },
  Template_getTemplateItems: {
    path: '/Templates/get-template-items',
  },
  Template_find: {
    path: '/Templates/find',
  },
  Progress_filterProgressId: {
    method: 'get',
    path: '/Progresses/filter-progress-id',
  },
  EntityConnection_properties: {
    method: 'get',
    path: '/EntityConnections/properties',
  },
  Progress_checkList: {
    method: 'get',
    path: '/Progresses/check-list',
  },
  SysMap_getUrlMap: {
    method: 'get',
    path: '/SysMaps/get-url-map',
  },
  Progress_AllProgress: {
    method: 'get',
    path: '/Progresses/all-progress',
  },
  Breadcrumb_findOne: {
    method: 'get',
    path: '/Breadcrumbs/findOne',
  },
  Breadcrumb_upsertWithWhere: {
    path: '/Breadcrumbs/upsertWithWhere',
    method: 'post',
    dataKey: 'data',
    queryKeys: ['where'],
    contentType: 'application/json',
  },
  AssetManager_getAssets: {
    method: 'get',
    path: '/AssetManagers/get-assets',
  },
  AssetManager_deleteAsset: {
    method: 'get',
    path: '/AssetManagers/delete-asset',
  },
  AssetManager_renameAsset: {
    method: 'get',
    path: '/AssetManagers/rename-asset',
  },
  AssetManager_createNewFolder: {
    method: 'get',
    path: '/AssetManagers/create-folder',
  },
  Helpy_getHelpy: {
    method: 'get',
    path: '/Helpies/get-helpy',
  },
  Helpy_save: {
    path: '/Helpies/save',
    method: 'post',
    contentType: 'application/json',
  },
  Helpy_findOne: {
    path: '/Helpies/findOne',
    method: 'get',
  },
  HelpyCategory_getCategories: {
    method: 'get',
    path: '/HelpyCategories/get-categories',
  },
  HelpyCategory_getCategoriesWithoutTree: {
    method: 'get',
    path: '/HelpyCategories/get-categories-without-tree',
  },
  HelpyCategory_upsertWithWhere: {
    path: '/HelpyCategories/upsertWithWhere',
    method: 'post',
    dataKey: 'data',
    queryKeys: ['where'],
    contentType: 'application/json',
  },
  HelpyCategory_getHelpyCategories: {
    method: 'get',
    path: '/HelpyCategories/get-helpy-categories',
  },
  HelpyCategory_deleteCategory: {
    method: 'post',
    path: '/HelpyCategories/delete-category',
    dataKey: 'data',
    contentType: 'application/json',
  },
  HelpyCategory_reorderCategories: {
    method: 'post',
    path: '/HelpyCategories/reorder-categories',
    dataKey: 'data',
    contentType: 'application/json',
  },
  Message_getMessages: {
    path: '/Messages/get-messages',
    method: 'get',
  },
  Message_filterMessages: {
    path: '/Messages/filter-messages',
    method: 'get',
  },
  Message_setMessageToRead: {
    path: '/Messages/set-message-to-read',
    method: 'post',
  },
  Message_countUnreadMessages: {
    path: '/Messages/count-unread-messages',
    method: 'get',
  },
  Translator_translate: {
    path: '/Translators/translate',
    method: 'get',
  },
  Ai_getPrompt: {
    path: '/Ais/get-prompt',
    method: 'get',
  },
  Ai_deleteVectorFile: {
    path: '/Ais/delete-vector-file',
    method: 'post',
  },
  Ai_updateKnowledge: {
    path: '/Ais/update-knowledge',
    method: 'get',
  },
  Ai_getMaxTokens: {
    path: '/Ais/get-max-tokens',
    method: 'get',
  },
  Ai_createThread: {
    path: '/Ais/create-thread',
    method: 'get',
  },
  Ai_getAssistants: {
    path: '/Ais/get-assistants',
    method: 'get',
  },
  Ai_ask: {
    path: '/Ais/ask',
    method: 'post',
  },
  Ai_chat: {
    path: '/Ais/chat',
    method: 'post',
  },
  ItemTemplType_getItemTypes: {
    path: '/ItemTemplTypes/find',
    method: 'get',
  },
  Calendar_getData: {
    path: '/Calendars/get-calendar-data',
    method: 'get',
  },
  RawSql_parse: {
    path: '/RawSqls/parse',
    method: 'post',
  },
  RawSql_validate: {
    path: '/RawSqls/validate',
    method: 'post',
  },
  RawSql_save: {
    path: '/RawSqls/save',
    method: 'post',
  },
  RawSql_find: {
    path: '/RawSqls/find',
  },
  RawSql_findOne: {
    path: '/RawSqls/findOne',
  },
  RawSql_getSetup: {
    path: '/RawSqls/get-setup',
  },
  LazyLoader_byTableAndField: {
    path: '/LazyLoaders/table-and-field',
    method: 'post',
  },
  LazyLoader_bySourceType: {
    path: '/LazyLoaders/by-source-type',
    method: 'post',
  },
  LazyLoader_listAstToSql: {
    path: '/LazyLoaders/list-ast-to-sql',
    method: 'post',
  },
  LazyLoader_queryListAst: {
    path: '/LazyLoaders/query-list-ast',
    method: 'post',
  },
  AiCodeReview_save: {
    path: '/AiCodeReviews/save',
    method: 'post',
  },
  AiCodeReview_getReview: {
    path: '/AiCodeReviews/get-review',
    method: 'get',
  },
  PaymentTransaction_getStatus: {
    path: '/PaymentTransactions/get-status',
    method: 'get',
  },
  PaymentMerchant_list: {
    path: '/PaymentMerchants/list',
    method: 'get',
  },
  Icons_getIcons: {
    path: '/Icons/get-icons',
    method: 'get',
  },
  AllowedFileExtension_get: {
    path: '/AllowedFileExtensions/get',
    method: 'get',
  },
}
